import React from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import { Body, Headline, Title1 } from '../../../../../components/Typography';
import { useTranslation } from 'react-i18next';

const LayoutWrapper = styled.div`
  background: url('https://cdn.zeplin.io/5f077a40a958c15c064f2ccd/assets/0AAAF5ED-4748-41D3-B1D0-BCB09EE231AD.svg');
  background-size: cover;

  padding: 22px 14px;

  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 5px 16px 0 rgba(66, 59, 112, 0.32);
  display: grid;
  grid-gap: 15px;

  height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '209px')};
  width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '314px')};

  @media (min-width: 1551px) {
    height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '289px')};
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '434px')};
  }

  @media (max-width: 360px) {
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '280px')};
  }
`;

const BalanceAndLogoWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 9.5px;
`;

const BalanceWrapper = styled.div`
  display: grid;
  grid-gap: 4px;
`;

const Balance = styled(Title1)`
  color: #000;
  font-weight: 600;
`;

const NextRewardWrapper = styled.div`
  background: #f067a0;

  border-radius: 9px;
  padding: 15px 10px;

  display: grid;
  grid-gap: 10px;
  min-height: 100px;
`;

const NextRewardOfferWrapper = styled.div`
  // display: grid;
  // grid-gap: 5px;
`;

const NextOffer = styled(Headline)`
  color: #fff;
  // margin-top: 5px;
`;

const Progress = styled.progress`
  width: 100%;
  height: 12px;
  border-radius: 0;
  border: 0;

  &::-moz-progress-bar {
    border: 0;
    border-radius: ${(props) => (props.layoutStyle == 'menu' ? '0' : '5.5px')};
  }

  &::-webkit-progress-bar {
    border: 0;
    border-radius: ${(props) => (props.layoutStyle == 'menu' ? '0' : '5.5px')};
    background-color: #fff;
  }

  &::-webkit-progress-value {
    border: 0;
    border-top-left-radius: ${(props) =>
      props.layoutStyle == 'menu' ? '0' : '5.5px'};
    border-bottom-left-radius: ${(props) =>
      props.layoutStyle == 'menu' ? '0' : '5.5px'};
    border-top-right-radius: 5.5px;
    border-bottom-right-radius: 5.5px;
    background-color: #56bbc1;
  }

  @media (max-width: 1550px) {
    height: 10px;
  }
`;

const PinksBurgerLoyaltyCard = (props) => {
  const { t } = useTranslation();
  return (
    <LayoutWrapper
      layoutStyle={props.layoutStyle}
      onClick={() => navigate('/offers')}
    >
      <BalanceAndLogoWrapper>
        <BalanceWrapper>
          <Body style={{ color: '#000' }}>{t('rewards.yourBalance')}:</Body>
          <Balance>
            {props.balance}{' '}
            {props.balance === 1 ? t('rewards.point') : t('rewards.points')}
          </Balance>
        </BalanceWrapper>
        {/* <img
          src="https://s3.amazonaws.com/assets.smoothpay.com/web/me-va-me-assets/group-17-copy%403x.png"
          width="82"
          height="51"
        /> */}
      </BalanceAndLogoWrapper>
      <NextRewardWrapper>
        {props.nextOfferTitle ? (
          <NextRewardOfferWrapper>
            <Body style={{ color: '#fff' }}>{t('rewards.nextReward')}:</Body>
            <NextOffer>{props.nextOfferTitle}</NextOffer>
          </NextRewardOfferWrapper>
        ) : (
          <NextOffer>{t('rewards.allRewardsUnlocked')}</NextOffer>
        )}
        <Progress
          max='100'
          value={props.nextOfferProgressValue}
          // layoutStyle={layoutStyle}
        />
      </NextRewardWrapper>
    </LayoutWrapper>
  );
};

export default PinksBurgerLoyaltyCard;
